<template>
	<GmapMap ref="mapRef"
		:center="{lat:43.5448, lng:-80.2482}"
		:zoom="14"
		map-type-id="roadmap"
		style="width: 100%; height: 100%"
	>
	</GmapMap>
</template>

<script>
	import {gmapApi} from 'vue2-google-maps';

	export default {
		props: ['address'],

		mounted () {
			// At this point, the child GmapMap has been mounted, but
			// its map has not been initialized.
			// Therefore we need to write mapRef.$mapPromise.then(() => ...)
			this.$refs.mapRef.$mapPromise.then((map) => {
				this.geocoder = new google.maps.Geocoder();
				this.goToAddress(map);
			})

		},

		data: function() {
		    return {
		        geocoder: null
		    };
		},

		computed: {
			google: function() {
				return gmapApi;
			},
		},

		methods: {
			goToAddress: function(map) {
				this.geocoder.geocode( { 'address': this.address}, function(results, status) {
					if (status == 'OK') {
					map.setCenter(results[0].geometry.location);
					var marker = new google.maps.Marker({
					    map: map,
					    position: results[0].geometry.location
					});
					} else {
						console.log('Geocode was not successful for the following reason: ' + status);
					}
					});
			},
		}
	}
</script>